import React from "react";
import OtpInput from "react-otp-input";
import { Field } from "formik";
import styled from "styled-components";

const OTPInput = (props) => (
  <Field name={props?.name}>
    {({ field, form }) => (
      <OTPSection className="app-input-text">
        <OtpInput
          value={field.value || ""}
          onChange={(evt) => {
            form.setFieldValue(props?.name, evt);
          }}
          inputStyle={props?.inputStyle}
          numInputs={props?.numInputs}
          separator={<span>-</span>}
          isInputNum={true}
        />
      </OTPSection>
    )}
  </Field>
);

export default OTPInput;

const OTPSection = styled.div`
  padding: 10px 5px;
  > div {
    justify-content: center;
    gap: 15px;
    > div {
      width: 40px;
      height: 40px;
      background: #f6f6f6;
      box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.12);
      border-radius: 10px;
      input {
        text-align: center;
        width: 100% !important;
        padding: 0;
        border: none;
        font-size: 14px;
        line-height: 23px;
      }
      span {
        display: none;
      }
    }
  }
`;
